import { render, staticRenderFns } from "./AppNotificationEdit.vue?vue&type=template&id=696c00cb&scoped=true&"
import script from "./AppNotificationEdit.vue?vue&type=script&lang=js&"
export * from "./AppNotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationEdit.vue?vue&type=style&index=0&id=696c00cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c00cb",
  null
  
)

export default component.exports